import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _AssetItemHistory, _FixedAssetItemAddition, _FixedAssetItemDeterioration, _FixedAssetItemDevaluation, _FixedAssetItemRevaluation } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { FixedAssetDepreciationTypeConstants } from "../FixedAssetDepreciationTypeConstants/FixedAssetDepreciationTypeConstants";

interface Props {
    idItem: number;
}

export const FixedAssetItemAddition = ({ idItem }: Props) => {

    const fixeditemaddition = useDataBean(_FixedAssetItemAddition);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [form, setform] = useState<any>({
        dperecation: 5,

    })
    useEffect(() => {
        getLista();
    }, [idItem, form.dperecation])

    const getLista = () => {

        fixeditemaddition.instance.getFixedAssetItemAdditionCatalog(idItem, form.dperecation).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        fixeditemaddition.setBean({
            IDItem: fixeditemaddition.bean.IDItem
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        fixeditemaddition.deleteItemVoid(fixeditemaddition.bean.IDAddition).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        fixeditemaddition.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDAddition', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha', property: 'InitDate', visible: true },
        { title: 'Cuenta Contable', property: 'AccountantIDName', visible: true },
        { title: 'Valor de Adición', property: 'AdditionValue', visible: true },

    ]




    return (
        <BasicPage titulo="Consultar Adiciones">
            <div className="row">
                <div className="col-md-4">
                    <FixedAssetDepreciationTypeConstants idSelector={form.dperecation} onChange={(e) => { setform(e) }} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={fixeditemaddition.setBean} ></BasicTable>

                </div>

            </div>
        </BasicPage>
    )
}